import moment from "moment";
import { LoadState, POLICIES } from "../../../constants/enums";
import { getUniqueId } from "../../../helpers";
import { STANDARD_APP_DATE_FORMAT, STANDARD_APP_TIME_FORMAT } from "../../../constants/constants";

export interface IHabitationalBasicDetailsState {
  customerInfo: {
    data: IHabitationalCustomerInfo;
    loading: LoadState;
    error: string | null;
  };
  additional_insured: {
    list: IHabitationalAdditionalInsured[];
    data: IHabitationalAdditionalInsured;
    loading: LoadState;
    error: string | null;
  };
  priorPolicy: {
    data: IHabitationalPriorPolicy;
    loading: LoadState;
  };
  policyAdmin: {
    data: IHabitationalPolicyAdmin;
    loading: LoadState;
  };
  policyAdminManager: {
    data: IHabitationalPolicyAdminManager;
    loading: LoadState;
  };
  premium: {
    data: IHabitationalPremium;
    loading: LoadState;
  };
  attachment: {
    list: IHabitationalAttachment[];
    listLoading: LoadState;
    data: IHabitationalAttachment;
    loading: LoadState;
    error: string | null;
  };
  customerNotFoundError: string | null;
  customerPoliycId?: number | null;
  isNewPolicy: boolean;
}

export interface IHabitationalCustomerInfo {
  policy_id: number;
  customer_id: number;
  customer_policy_id: number;
  customer_name: string | null;
  customer_code: string | null;
  form_of_business: string | number | null;
  language: string | null;
  line_of_business: string | null;
  sub_type: string | null;
  effective_date: string;
  expiry_date: string;
  transaction_type: string | null;
  residential_or_business: string | null;
  address: string | null;
  unit_or_suite: string | null;
  city: string | null;
  province_or_state: string | null;
  postal_code: string | null;
  country: string | null;
  segment: string[];
  policy_status: string | null;
  current_policy_status: string | null;
  date_cancelled: string | null;
  cancellation_reason: string | null;
  cancellation_type: string | null;
  program: string | null;
  type_of_policy: string | null;
  quote_number: string | null;
  policy_number: string | null;
  binder_number: string | null;
  effective_time: string;
  send_invoices_renewal_and_receivacble_letter_via_emails: boolean | null;
  send_statements_via_email: boolean | null;
  send_eDocs_via_email: boolean | null;
  status: string;
  additional_insured: IHabitationalAdditionalInsured[];
}

export interface IHabitationalAdditionalInsured {
  customer_policy_id: number | null;
  incremental_number: null;
  customer_id: number;
  type: string | null;
  customer_name: string | null;
  address: string | null;
  unit_or_suite: string | null;
  city: string | null;
  province_or_state: string | null;
  country: string | null;
  postal_code: string | null;
  phone_number: string | null;
  mobile_number: string | null;
  gender: string | null;
  birth_date: string | null;
  marital_status: string | null;
  status: string;
}

export interface IHabitationalPriorPolicy {
  customer_policy_id: number;
  line_of_business: string | null;
  policy_expiry_date: string | null;
  current_insurer: string | null;
  expiring_premium: string | null;
  current_status: string | null;
  non_payment_code: string | null;
  non_payment_date: string | null;
  insurer: string | null;
  amount_owing: string | null;
  prior_policy_number: string | null;
}

export interface IHabitationalPolicyAdmin {
  customer_policy_id: number;
  insurer: string | null;
  broker_code: string | null;
  broker_sub_code: string | null;
  comission_code: string | null;
  commission_percentage: string | null;
  policy_fee: string | null;
  branch_code: string | null;
  producer_one: string | null;
  producer_one_code: string | null;
  producer_two: string | null;
  producer_two_code: string | null;
  producer_three: string | null;
  producer_three_code: string | null;
  marketer: string | null;
  marketer_code: string | null;
  csr: string | null;
  csr_code: string | null;
  billing_account_number: string | null;
}
export interface IHabitationalPolicyAdminManager {
  customer_policy_id: number;
  insurer: string | null;
  broker_code: string | null;
  broker_sub_code: string | null;
  comission_code: string | null;
  policy_fee: string | null;
  branch_code: string | null;
  producer_one: string | null;
  producer_one_code: string | null;
  producer_two: string | null;
  producer_two_code: string | null;
  producer_three: string | null;
  producer_three_code: string | null;
  marketer: string | null;
  marketer_code: string | null;
  csr: string | null;
  csr_code: string | null;
  billing_account_number: string | null;

  producer_one_endorsement_percentage: string | null;
  producer_one_new_percentage: string | null;
  producer_one_renewal_percentage: string | null;

  producer_two_endorsement_percentage: string | null;
  producer_two_new_percentage: string | null;
  producer_two_renewal_percentage: string | null;

  producer_three_endorsement_percentage: string | null;
  producer_three_new_percentage: string | null;
  producer_three_renewal_percentage: string | null;

  house_new_percentage: string | null;
  house_renewal_percentage: string | null;
  house_endorsement_percentage: string | null;

  branch_new_percentage: string | null;
  branch_renewal_percentage: string | null;
  branch_endorsement_percentage: string | null;
}
export interface IHabitationalPremium {
  customer_policy_id: number;
  policy_premium: string | null;
  agency_bill_or_direct_bill: string | null;
  payment_plan: string | null;
  premium_finance_contract_number: string | null;
  premium_finance: string | null;
  financed_by: string | null;
  default_tax_region: string | null;
  tax_one: string | null;
  tax_two: string | null;
  tax_exempt: string | null;
  reason: string | null;
  payment_schedule: IHabitationalCsioPremiumPaymentSchedule[];
}

export interface IHabitationalCsioPremiumPaymentSchedule {
  id: string;
  installment_number: string;
  installment_amount: string;
  installment_date: string;
}

export interface IHabitationalAttachment {
  customer_policy_id: number | null;
  serial_number: number | null;
  document_name: string | null;
  file_upload: string | null;
  description: string | null;
  status: string;
  send_attachment: number;
}

export const initialHabitationalDetails: IHabitationalBasicDetailsState = {
  customerInfo: {
    data: {
      policy_id: 0,
      customer_name: "",
      customer_policy_id: 0,
      customer_id: 0,
      customer_code: null,
      form_of_business: null,
      language: null,
      line_of_business: POLICIES.HABITATIONAL_POLICY,
      sub_type: null,
      effective_date: moment().format(STANDARD_APP_DATE_FORMAT),
      expiry_date: moment().add(1, "year").format(STANDARD_APP_DATE_FORMAT),
      transaction_type: null,
      address: "",
      unit_or_suite: "",
      city: "",
      province_or_state: "",
      country: "",
      postal_code: "",
      policy_status: "",
      current_policy_status: "Prospect",
      date_cancelled: null,
      cancellation_reason: null,
      cancellation_type: null,
      program: null,
      type_of_policy: null,
      residential_or_business: null,
      quote_number: null,
      policy_number: null,
      segment: [],
      binder_number: null,
      effective_time: moment().startOf("day").add(1, "minute").format(STANDARD_APP_TIME_FORMAT),
      send_invoices_renewal_and_receivacble_letter_via_emails: true,
      send_statements_via_email: true,
      send_eDocs_via_email: true,
      status: "ACTIVE",
      additional_insured: []
    },
    loading: LoadState.NotLoaded,
    error: null,
  },
  additional_insured: {
    data: {
      customer_policy_id: 0,
      incremental_number: null,
      customer_id: 0,
      type: null,
      customer_name: null,
      address: null,
      unit_or_suite: null,
      city: null,
      province_or_state: null,
      country: null,
      postal_code: null,
      phone_number: null,
      mobile_number: null,
      gender: null,
      birth_date: null,
      marital_status: null,
      status: "ACTIVE",
    },
    list: [],
    loading: LoadState.NotLoaded,
    error: null,
  },
  priorPolicy: {
    data: {
      customer_policy_id: 0,
      line_of_business: null,
      policy_expiry_date: null,
      current_insurer: null,
      expiring_premium: null,
      current_status: null,
      non_payment_code: null,
      non_payment_date: null,
      insurer: null,
      amount_owing: null,
      prior_policy_number: null
    },
    loading: LoadState.NotLoaded,
  },
  policyAdmin: {
    data: {
      customer_policy_id: 0,
      insurer: null,
      broker_code: null,
      broker_sub_code: null,
      comission_code: null,
      commission_percentage: null,
      policy_fee: null,
      branch_code: null,
      producer_one: null,
      producer_one_code: null,
      producer_two: null,
      producer_two_code: null,
      producer_three: null,
      producer_three_code: null,
      marketer: null,
      marketer_code: null,
      csr: null,
      csr_code: null,
      billing_account_number: null,
    },
    loading: LoadState.NotLoaded,
  },
  policyAdminManager: {
    data: {
      customer_policy_id: 0,
      insurer: null,
      broker_code: null,
      broker_sub_code: null,
      comission_code: null,
      policy_fee: null,
      branch_code: null,
      producer_one: null,
      producer_one_code: null,
      producer_two: null,
      producer_two_code: null,
      producer_three: null,
      producer_three_code: null,
      marketer: null,
      marketer_code: null,
      csr: null,
      csr_code: null,
      billing_account_number: null,

      producer_one_endorsement_percentage: null,
      producer_one_new_percentage: null,
      producer_one_renewal_percentage: null,
      producer_two_endorsement_percentage: null,
      producer_two_new_percentage: null,
      producer_two_renewal_percentage: null,
      producer_three_endorsement_percentage: null,
      producer_three_new_percentage: null,
      producer_three_renewal_percentage: null,
      house_new_percentage: null,
      house_renewal_percentage: null,
      house_endorsement_percentage: null,
      branch_renewal_percentage: null,
      branch_new_percentage: null,
      branch_endorsement_percentage: null,
    },
    loading: LoadState.NotLoaded,
  },
  premium: {
    data: {
      customer_policy_id: 0,
      policy_premium: null,
      agency_bill_or_direct_bill: null,
      payment_plan: null,
      premium_finance_contract_number: null,
      premium_finance: null,
      financed_by: null,
      default_tax_region: "ON",
      tax_one: null,
      tax_two: null,
      tax_exempt: null,
      reason: null,
      payment_schedule: [
        {
          id: getUniqueId(),
          installment_number: "",
          installment_amount: "",
          installment_date: "",
        },
        {
          id: getUniqueId(),
          installment_number: "",
          installment_amount: "",
          installment_date: "",
        },
        {
          id: getUniqueId(),
          installment_number: "",
          installment_amount: "",
          installment_date: "",
        },
        {
          id: getUniqueId(),
          installment_number: "",
          installment_amount: "",
          installment_date: "",
        },
        {
          id: getUniqueId(),
          installment_number: "",
          installment_amount: "",
          installment_date: "",
        },
        {
          id: getUniqueId(),
          installment_number: "",
          installment_amount: "",
          installment_date: "",
        },
        {
          id: getUniqueId(),
          installment_number: "",
          installment_amount: "",
          installment_date: "",
        },
        {
          id: getUniqueId(),
          installment_number: "",
          installment_amount: "",
          installment_date: "",
        },
        {
          id: getUniqueId(),
          installment_number: "",
          installment_amount: "",
          installment_date: "",
        },
        {
          id: getUniqueId(),
          installment_number: "",
          installment_amount: "",
          installment_date: "",
        },
        {
          id: getUniqueId(),
          installment_number: "",
          installment_amount: "",
          installment_date: "",
        },
        {
          id: getUniqueId(),
          installment_number: "",
          installment_amount: "",
          installment_date: "",
        },
      ],
    },
    loading: LoadState.NotLoaded,
  },
  attachment: {
    list: [],
    listLoading: LoadState.NotLoaded,
    data: {
      customer_policy_id: null,
      serial_number: null,
      document_name: null,
      file_upload: null,
      description: null,
      status: "ACTIVE",
      send_attachment: 0,
    },
    loading: LoadState.NotLoaded,
    error: null,
  },
  customerNotFoundError: null,
  customerPoliycId: null,
  isNewPolicy: true,
};
